import React, { useState } from 'react';
import { useTranslation, Trans } from 'react-i18next';
import PropTypes from 'prop-types';

import {
  Layer,
  TimeInput,
} from '~/notify/settings/__modules__/component';
import { useDialog } from '~/__modules__/dialog';

TimeSetting.propTypes = {
  onCancle: PropTypes.func,
  onOk: PropTypes.func,
  defaultValue: PropTypes.object.isRequired,
}; 

const checkAndFormatTime = (time = '') => {
  let timeArr = time.split(':');
  const reg = /^[0-9]{2}$/;
  if (timeArr && timeArr.length == 2) {
    let [hour, minute] = timeArr.map((item) => {
      if (reg.test(item)) {
        return parseInt(item);
      } else {
        return NaN;
      }
    });
    if (
      !isNaN(hour) &&
      !isNaN(minute) &&
      hour >= 0 &&
      hour < 24 &&
      minute >= 0 &&
      minute < 60
    ) {
      return { hour, minute };
    }
  }
  return null;
}



export function TimeSetting({ onCancle, onOk, defaultValue }) {
  const dialog = useDialog();
  const { t } = useTranslation();
  const WEEK = [
    { label: t('noti_mon1'), value: 1 },
    { label: t('noti_tue1'), value: 2 },
    { label: t('noti_wen1'), value: 3 },
    { label: t('noti_thu1'), value: 4 },
    { label: t('noti_fri1'), value: 5 },
    { label: t('noti_sat1'), value: 6 },
    { label: t('noti_sun1'), value: 0 },
  ];
  const [timeOption, setTimeOption] = useState(defaultValue);

  const onWeekChange = (week) => {
    const weekdays = [...timeOption.weekdays];
    const index = weekdays.indexOf(week);
    if (index > -1 && weekdays.length === 1) {
      showDialog(t('noti_alert_pop3'));
      return;
    }
    if (index > -1) {
      weekdays.splice(index, 1);
    } else {
      weekdays.push(week);
    }
    setTimeOption({
      ...timeOption,
      weekdays,
    });
  };
  const onTimeChange = (key, value) => {
    setTimeOption({
      ...timeOption,
      [key]: value,
    });
  };

  
  const onSave = () => {
    const params = {...timeOption};
    const start = checkAndFormatTime(params.startTime);
    const end = checkAndFormatTime(params.endTime);
    if (!start || !end) {
      showDialog(<Trans i18nKey="noti_alert_pop4" />);
      return;
    } else if (start.hour === end.hour && start.minute === end.minute) {
      showDialog(<Trans i18nKey="noti_alert_pop5" />);
      return;
    }
    params.weekdays = params.weekdays.sort();
    onOk(params);
  };

  const showDialog = (title = '') => {
    dialog.alert((action) => ({
      title,
      description: '',
      [action()]: (close) => {
        close && close();
      },
    }));
  };


  return (
    <Layer className="ly_auto_reply">
      <h3 className="title">{t('noti_alert_time')}</h3>
      <div className="layer_contents">
        <ul className="days_list">
          {WEEK.map((item) => {
            return (
              <li
                className="item"
                key={item.label}
                onClick={() => onWeekChange(item.value)}
              >
                <input
                  type="checkbox"
                  className="days_checkbox"
                  checked={timeOption.weekdays.includes(item.value)}
                  onChange={() => {}}
                />
                <label>{item.label}</label>
              </li>
            );
          })}
        </ul>
      </div>
      <div className="time_box">
        <TimeInput
          value={timeOption.startTime}
          onChange={(event) => onTimeChange('startTime', event.target.value)}
        />
        <span className="hyphen">
          <i className="blind">-</i>
        </span>
        <TimeInput
          value={timeOption.endTime}
          onChange={(event) => onTimeChange('endTime', event.target.value)}
        />
      </div>

      <div className="btn_area">
        <button type="button" className="lw_btn_40" onClick={(e) => onCancle()}>
          {t('button_cancel')}
        </button>
        <button
          type="button"
          className="lw_btn_point_40"
          onClick={(e) => onSave()}
        >
          {t('button_save')}
        </button>
      </div>
      <button type="button" className="btn_close" onClick={(e) => onCancle()}>
        {t('button_close')}
      </button>
    </Layer>
  );
}
